<template>
  <div>

    <div>
      <div v-if="!sent">
        <ValidationObserver ref="form" @submit.prevent="formValidate()">
            <form @submit.prevent="formValidate">

              <div class="form__frow form__frow--split">

                <div class="form-group">

                  <validation-provider ref="fr-location" name="Location" rules="required" v-slot="{ errors }">
                    <label for="field-location">Select your NZ location</label>
                    <div class="select-element">
                      <select
                        name="location"
                        class="form-control"
                        id="field-location"
                        aria-describedby="fieldLocation"
                        v-model="fieldLocation"
                      >
                        <option value="" selected>-</option>
                        <option value="Northland">Northland</option>
                        <option value="Thames Valley">Thames Valley</option>
                        <option value="Waikato">Waikato</option>
                        <option value="Bay of Plenty">Bay of Plenty</option>
                        <option value="Tongariro">Tongariro</option>
                        <option value="East Cape">East Cape</option>
                        <option value="Hawkes Bay">Hawke's Bay</option>
                        <option value="Taranaki">Taranaki</option>
                        <option value="Wanganui">Wanganui</option>
                        <option value="Wairarapa">Wairarapa</option>
                        <option value="Manawatu">Manawatu</option>
                        <option value="Horowhenua">Horowhenua</option>
                        <option value="Nelson Bays">Nelson Bays</option>
                        <option value="Marlborough">Marlborough</option>
                        <option value="Canterbury">Canterbury</option>
                        <option value="West Coast">West Coast</option>
                        <option value="Aorangi">Aorangi</option>
                        <option value="Coastal / North Otago">Coastal / North Otago</option>
                        <option value="Clutha / Central Otago">Clutha / Central Otago</option>
                        <option value="Southland">Southland</option>
                      </select>
                    </div>
                    <span id="fieldLocation" class="form-text text-muted js-ferror">{{ errors[0] }}</span>
                  </validation-provider>

                </div>

              </div>

              <div class="form__frow form__frow--split">

                <div class="form-group">
                  <validation-provider ref="fr-name" name="Name" rules="required" v-slot="{ errors }">
                    <label for="field-name">Name</label>
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      id="field-name"
                      aria-describedby="fieldName"
                        v-model="fieldName"
                    >
                    <span id="fieldName" class="form-text text-muted js-ferror">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <validation-provider ref="fr-company" name="Company" rules="" v-slot="{ errors }">
                    <label for="field-company">Company</label>
                    <input
                      type="text"
                      name="company"
                      class="form-control"
                      id="field-company"
                      aria-describedby="fieldCompany"
                      v-model="fieldCompany"
                    >
                    <span id="fieldCompany" class="form-text text-muted js-ferror">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

              </div>

              <div class="form__frow form__frow--split">

                <div class="form-group">
                  <validation-provider ref="fr-phone" name="Phone" rules="required" v-slot="{ errors }">
                    <label for="field-phone">Phone</label>
                    <input
                      type="text"
                      name="phone"
                      class="form-control"
                      id="field-phone"
                      aria-describedby="fieldPhone"
                      v-model="fieldPhone"
                    >
                    <span id="fieldPhone" class="form-text text-muted js-ferror">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <validation-provider ref="fr-email" name="Email" rules="required|email" v-slot="{ errors }">
                    <label for="field-email">Email</label>
                    <input
                      type="text"
                      name="email"
                      class="form-control"
                      id="field-email"
                      aria-describedby="fieldEmail"
                      v-model="fieldEmail"
                    >
                    <span id="fieldEmail" class="form-text text-muted js-ferror">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

              </div>

              <div class="form__frow">

                <div class="form-group">
                  <validation-provider ref="fr-message" name="Message" rules="required" v-slot="{ errors }">
                    <label for="field-message">Message</label>
                    <textarea
                      name="message"
                      class="form-control"
                      id="fieldMessage"
                      rows="4"
                      v-model="fieldMessage"
                    ></textarea>
                    <span id="fieldMessage" class="form-text text-muted js-ferror">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

              </div>


              <div class="form__frow form__frow--split form__frow--action form__frow--justify">

                <div class="custom-control custom-checkbox form-tm">
                  <input name="newsletter" type="checkbox" class="custom-control-input" id="field-newsletter" ref="newsletter-checkbox">
                  <label class="custom-control-label" for="field-newsletter">Hear about Cobra deals & news</label>
                </div>

                <div>

                  <div class="form-action">
                    <validation-provider ref="fr-btn" v-slot="{ errors }">
                      <button type="submit" class="btn btn-custom btn-light" :class="formProgress ? 'btn-loading' : ''"><span>Enquire Now</span></button>
                      <span id="fieldBtn" class="form-text text-muted js-ferror">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>

                </div>

              </div>

          </form>
        </ValidationObserver>
      </div>
      <transition name="fade">
        <div ref="enquiry-message" class="form form--screencomplete" v-if="sent">
          <span v-text="sent.title"></span>
          <div v-html="sent.text"></div>
        </div>
      </transition>
    </div>

  </div>
</template>

<script>

    import FormInstance from '../mixins/FormInstance'
    import jump from 'jump.js'

    export default {

        name: 'enquiry-form',

        mixins: [ FormInstance ],

        data() {

            return {

                // fields
                fieldLocation: '',
                fieldName: '',
                fieldCompany: '',
                fieldPhone: '',
                fieldEmail: '',
                fieldMessage: '',
                fieldNewsletter: false,

                recaptchaName: 'newsletter'

            }

        },

        methods: {

            formProceed(token) {

              var data = new FormData();

              data.append('t', token);
              data.append('location', this.fieldLocation);
              data.append('name', this.fieldName);
              data.append('company', this.fieldCompany);
              data.append('phone', this.fieldPhone);
              data.append('email', this.fieldEmail);
              data.append('message', this.fieldMessage);
              data.append('newsletter', $(this.$refs['newsletter-checkbox']).is(':checked'));

              axios.post(this.supplies.link, data).then(response => {

                this.formProgress = false;

                if(response.data.errors) {

                  this.errorHandler(response.data.errors, 'fr-btn');

                } else {

                  var tplink;

                  if ($('body').attr('data-page') === 'Home') {
                    tplink = '/home/thank-you'
                  } else {
                    tplink = window.location.pathname + (window.location.pathname && window.location.pathname.substr(-1) === '/' ? '' : '/')
                    tplink += 'thank-you'
                  }

                  window.location = tplink

                  // this.sent = response.data.message;

                  // this.sent.text = this.sent.text.replace('[name]', this.fieldName);

                  // this.$nextTick(() => {

                  //   jump(this.$refs['enquiry-message'], {
                  //     duration: 600,
                  //     offset: -($('.g.g--header').height() + 50)
                  //   });

                  // });

                }

              }, error => {

                this.formProgress = false;

                this.errorHandler({ btn: 'Request has failed, please try again.' }, 'fr-btn'); // error

              });

            }

        }

    }
</script>
